import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { reduxForm, propTypes as formPropTypes, Field } from 'redux-form';
import { TextStyled } from '@nike/nike-design-system-components';
import { nike } from '@nike/nike-design-tokens';

import { departmentsTypes, userAccountTypes, userTypes } from '../types/user';

import { TranslatedCopy } from '../intl/TranslatedCopy';

import { RadioList } from '../components';
import Select from '~COMPONENTS/formInputs/Select';

import { updateSelectOption } from './actions';
import { selections } from './reducer';
import { selectDepartments, getUserAccount, getUserData } from '../user/selectors';

import { isAdmin } from '../util/rolePermissions';

import { PAYMENT_COMP, PAYMENT_BILLABLE } from '../shop/constants';
import { CONTRACT_PERIOD_CURRENT, CONTRACT_PERIOD_FUTURE } from './constants';
import { getIsGreaterChinaSalesOrg } from '../gamedayAccount/selectors';

export const DownloadModalTransactionReports = ({
  updateSelectOption,
  selections,
  departments,
  account,
  user,
  isGreaterChinaSalesOrg
}) => {
  if (!selections || !selections.transactionReport_type) updateSelectOption({ transactionReport_type: PAYMENT_COMP });

  const onTypeChange = ({ value }) => updateSelectOption({ transactionReport_type: value });
  const onPeriodChange = ({ value }) => updateSelectOption({ transactionReport_period: value });
  const onDepartmentChange = ({ value }) => updateSelectOption({ transactionReport_department: value });

  const departmentOptions = departments
    .filter(dept => dept.customerNumber === account.number)[0]
    .customerDepartments.map(dept => ({
      label: dept.customerDepartmentName,
      value: dept.customerDepartmentCode
    }));
  // --
  if (isAdmin(user.role))
    departmentOptions.unshift({
      label: new TranslatedCopy({ id: 'gridwall.allDepartments' }).toString(),
      value: 'ALL'
    });

  return (
    <div className='downloadModal flex-container column start ta-sm-l text-color-primary-dark'>
      <div className='downloadModal_transactionReport pt2-sm ta-sm-l'>
        <div className='pb2-sm'>
          <RadioList
            name='downloadModal_transactionReport_radioList'
            options={
              !isGreaterChinaSalesOrg
                ? [
                    {
                      label: new TranslatedCopy({ id: 'transactions.history.type.comp' }).toString(),
                      value: PAYMENT_COMP
                    },
                    {
                      label: new TranslatedCopy({ id: 'transactions.history.type.billable' }).toString(),
                      value: PAYMENT_BILLABLE
                    }
                  ]
                : [
                    {
                      label: new TranslatedCopy({ id: 'transactions.history.type.comp' }).toString(),
                      value: PAYMENT_COMP
                    }
                  ]
            }
            value={selections && selections.transactionReport_type ? selections.transactionReport_type : PAYMENT_COMP}
            onChange={onTypeChange}
          />
          {selections && selections.transactionReport_type === PAYMENT_BILLABLE && (
            <TextStyled style={{ paddingLeft: '20px', color: nike.podiumCdsColorRed500, fontSize: '11px' }} bold>
              <TranslatedCopy id='transactions.history.taxinfo' />
            </TextStyled>
          )}
        </div>
        <div className='downloadModal_transactionReport_selectBlock'>
          <p className='mb2-sm'>
            <TranslatedCopy id='transactions.history.period.copy' />
          </p>
          <div>
            <Field
              name='downloadModal_transactionReport_period'
              component={Select}
              label={new TranslatedCopy({
                id: 'transactions.history.period.select'
              }).toString()}
              options={[
                /*
                {
                  label: new TranslatedCopy({ id: 'transactions.history.period.past' }).toString(),
                  value: CONTRACT_PERIOD_PAST
                },
                */
                {
                  label: new TranslatedCopy({
                    id: 'transactions.history.period.current'
                  }).toString(),
                  value: CONTRACT_PERIOD_CURRENT
                },
                {
                  label: new TranslatedCopy({
                    id: 'transactions.history.period.future'
                  }).toString(),
                  value: CONTRACT_PERIOD_FUTURE
                }
              ]}
              onChange={onPeriodChange}
              clearable={false}
              forceDropdown
              ignoreCase
            />
            <Field
              name='downloadModal_transactionReport_department'
              component={Select}
              label={new TranslatedCopy({
                id: 'shop.deptSelect.title'
              }).toString()}
              options={departmentOptions}
              onChange={onDepartmentChange}
              clearable={false}
              forceDropdown
              ignoreCase
            />
          </div>
        </div>
      </div>
    </div>
  );
};

DownloadModalTransactionReports.propTypes = {
  ...formPropTypes,
  updateSelectOption: PropTypes.func.isRequired,
  selections: PropTypes.object,
  departments: departmentsTypes,
  account: userAccountTypes,
  user: userTypes,
  isGreaterChinaSalesOrg: PropTypes.bool.isRequired
};

DownloadModalTransactionReports.defaultProps = {
  selections: null,
  departments: null,
  account: null,
  user: null
};

const mapStateToProps = state => ({
  downloadTransactionsForm: state.form.downloadTransactionsForm,
  selections: selections(state),
  departments: selectDepartments(state),
  account: getUserAccount(state),
  user: getUserData(state),
  isGreaterChinaSalesOrg: getIsGreaterChinaSalesOrg(state)
});

const connector = connect(mapStateToProps, {
  updateSelectOption
});

export default reduxForm({
  form: 'downloadTransactionsForm'
})(connector(DownloadModalTransactionReports));
